import script from "./app-download.vue?vue&type=script&setup=true&lang=js"
export * from "./app-download.vue?vue&type=script&setup=true&lang=js"

import "./app-download.vue?vue&type=style&index=0&id=527de01f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-527de01f"]])

export default __exports__